import {
  storage
} from '../storage'
import requestData from '../dataservice'
import {
  _,
  localizeHTMLTag,
  getParameterValue,
  translateAll
} from '../lang'
import {
  localiseInterface
} from '../localizeservice'
import {
  xml
} from 'd3-request'
import {
  select
} from 'd3-selection'
import {
  processDataForCategory,
  processData,
  indicatorClick,
  CHECKED_FA_HTML,
  UNCHECKED_FA_HTML,
  currentCategory,
  selectedSortProperty,
  selectedSortDirection,
  groups,
  currentSorting,
  setcurrentSortingCS,
  selectedSortPropertyCS,
  selectedSortDirectionCS,
  changeParams
} from '../main'

const config = require ('../../../../configs/configuration.js')
const constants = config.configuration.data;
var indicators;

/* 
UI To change indicator : 
CHECKBOXES
*/

export function createIndSelectionCheckBoxes() {
  indicators = window.indicators;
  $("#chartInd").html("<div id=\"sortContainer\"></div>");

  $("#sortContainer").empty();
  if (indicators.length > 1) {
      indicators = window.indicators;
      for (var [index, entry] of indicators.entries()) {
          const chapter = entry.code.replace(/\./g, '_')
          const hoverTitle = `indicator${chapter}.hoverTitle`
          var code = index;
          var title = _(hoverTitle);
          var checked = index == 0;

          if (checked) {
              $("#sortContainer").append('<div class="checkbox checkbox-success" data-checked="true" id="checkbox' + index + '">' + CHECKED_FA_HTML + '<label for="checkbox' + code + '">' + title + '</label></div>');
          } else {
              $("#sortContainer").append('<div class="checkbox checkbox-success" id="checkbox' + index + '">' + UNCHECKED_FA_HTML + '<label for="checkbox' + code + '">' + title + '</label></div>');
          }
      }
      handleIndCheckbox();
  }
}

function handleIndCheckbox() {
  $(".checkbox").click(function() {
      if ($(this).attr("data-checked") === "true") {
          return false;
      };

      // need to change the div content of each.
      updateCheckboxes(this);

      // get category and load the data
      var category = $(this).attr("id").replace('checkbox', '');
      indicatorClick(category);
  });
}

function updateCheckboxes(activeElement) {
  // there can only be one active element:
  $(".checkbox").not(activeElement).attr("data-checked", "false");
  $(activeElement).attr("data-checked", "true");

  // change all checkboxes to have content as if not checked. 
  $(".checkbox").find('span').remove();
  $(".checkbox").not(activeElement).prepend(UNCHECKED_FA_HTML);

  // find the one that is checked, and set it's content to checked.
  $(activeElement).prepend(CHECKED_FA_HTML);
}
/* 
UI To change indicator : 
BIG SQUARE ICONS
*/

export function createIndSelectionBigIcons() {
  indicators = window.indicators;
  if (indicators.length == 1) {
      return;
  }

  'use strict'

  // get container
  const iconsContainer = document.getElementById('icons-container')

  // remove visible tooltips, after clearing innerHTML no longer accessible
  $('[data-tooltip="tooltip"]').tooltip('dispose')

  // recreate
  iconsContainer.innerHTML = ''

  // add icons dynamically based on chapter information
  for (var [index, entry] of indicators.entries()) {
      const chapter = entry.code.replace(/\./g, '_')

      const iconSrc = require(`../../img/${chapter}.svg`)
      // d3.xml(iconSrc, function (xml) {
      // xml(iconSrc, function (xml) {
      //   let icon = document.importNode(xml.documentElement, true)
      const icon = new window.Image()
      icon.src = iconSrc
      icon.setAttribute('style', 'width: 55px; height: 55px;')

      // d3.select('div#icons-container')
      // select('div#icons-container')
      //   .each(function () {
      let div = document.createElement('button')
      if (index === window.categorySelected) {
          div.setAttribute('class', 'btn btn-default btn-xl icon-active')
          div.setAttribute('style', `background-color: ${constants.iconColorSelected}`)
      } else {
          div.setAttribute('class', 'btn btn-default btn-xl icon-nonactive')
          div.setAttribute('style', `background-color: ${constants.iconColorNotSelected}`)

          $(div).hover(function() {
              $(this).css('background-color', constants.iconColorSelected)
          }, function() {
              $(this).css('background-color', constants.iconColorNotSelected)
          })

          div.onclick = createOnClick(index)
      }

      const hoverTitle = `indicator${chapter}.hoverTitle`
      div.setAttribute('title', _(hoverTitle))
      div.setAttribute('data-tooltip', 'tooltip')
      div.setAttribute('data-placement', 'top')
      div.setAttribute('container', 'body')
      div.setAttribute('role', 'tooltip')
      div.setAttribute('id', chapter)
      div.appendChild(icon)

      iconsContainer.appendChild(div)

  }

  // activate all tooltips
  $('[data-tooltip="tooltip"]').tooltip({
      container: '#dummy'
  })
}
export function createOnClick(category) {
  return function() {
      $.when(requestData(category)).done(function() {
          window.categorySelected = category
          const data = storage.processedData[category]
          createIndSelectionBigIcons()

          // localise
          localiseInterface(category);
          processDataForCategory(category);
          //drawLinechart(data, 'linechart', category)
      })
  }
}

/* 
UI To change indicator : 
SELECTBOX
*/

export function createIndSelectionSelectbox() {

  $("#selectIndi").show();
  $("#selectIndi").empty();
  $("#selectIndi").unbind('click');

  var indicators = window.indicators;
  var iterator = 0;
  for (var [index, entry] of indicators.entries()) {
      const chapter = entry.code.replace(/\./g, '_')
      const hoverTitle = `indicator${chapter}.hoverTitle`
      $("#selectIndi").append('<option value="' + iterator + '">' + _(hoverTitle) + '</option>');
      iterator++;
  }
  $('#selectIndi').selectpicker();

  $("#selectIndi").change(function() {
      var category = $('#selectIndi option:selected').val();
      indicatorClick(category);

  });
}

export function buildCustomList() {
  var indicators = window.indicators;
  const paramIndicator = indicators[currentCategory];
  const params = paramIndicator.params;

  for (var key in params) {
      const valuesArr = params[key];
      if (valuesArr["type"] == "list") {

          var sel = $('<select>').attr("id", valuesArr["listId"]).attr("style", "display:none").appendTo(valuesArr["conteiner"]);
          $(valuesArr["items"]).each(function() {
              sel.append($("<option>").attr('value', this.code).text(_(this.title)));
          });
          sel.val(getParameterValue(valuesArr.urlParam));
          sel.on("change", function() {
              changeParams(key, this.value);
              delete storage.processedData[window.categorySelected];
              jQuery.when(requestData(window.categorySelected)).done(function() {
                  processData(window.categorySelected, currentSorting);
              });

          })

          $("#" + valuesArr["listId"]).selectpicker(getParameterValue(valuesArr.visibleParam) == "false" ? "hide" : "show");
          if (getParameterValue(valuesArr.visibleParam) == "false") {
              //$("#dropdown-container").addClass("disabled");
          }

      }
  }

}

/* Sorting */
export function checkSortIcons(selectedSortProperty, selectedSortDirection) {
  $('.sort')

      .off('click')

      .on('click', applySort)


  // check, which icons to display for the sorts!

  $('.sort i')

      .removeClass('fa-sort')

      .removeClass('fa-sort-down')

      .removeClass('fa-sort-up')

  $('#sort_' + selectedSortProperty + ' i').addClass('fa-sort-down')

  $('#sort_' + selectedSortProperty + ' i').attr(

      'title',

      selectedSortDirection === 'desc' ? _('sort.hover.ascending') : _('sort.hover.descending')

  )

  $('.sort i').each(function(idx, element) {

      if (!$(element).hasClass('fa-sort-down') && !$(element).hasClass('fa-sort-up')) {

          $(element).addClass('fa-sort')

      }

  })

}

export function applySort(event) {

  var indicators = window.indicators;

  event.stopPropagation();
  event.preventDefault();
  var e = event.currentTarget.id;
  var g = selectedSortDirection;
  var p = selectedSortProperty;

  e = e.substr(5, e.length - 1);

  g = p === e ? "desc" === g ? "asc" : "desc" : (p = e, "desc")

  const grouping = indicators[currentCategory].grouping;

  var index = groups.indexOf(e);

  setcurrentSortingCS(grouping.groups[index].code);
  selectedSortPropertyCS(e);
  selectedSortDirectionCS(g);

  processData(window.categorySelected, currentSorting, g);

}
export {
  selectedSortProperty,
  selectedSortDirection,
  currentSorting

};